<template>
    <div class='breadcrumbs'>
        <div class='crumbs' v-for="(crumb, i) in breadcrumbs" :key="crumb.id">
            <div v-show='i != 0 '><i class="fa-light fa-chevron-right" style="font-size: 0.7rem;"></i></div>
            <div class='crumb' @click="crumbClick(crumb)">{{crumb.name}}</div>
        </div>
    </div>
</template>

<script>
import {checkAuth} from "@/global/modules/functions.js";

export default {
    props: { custom_breadcrumbs: {default: []} },
    emits: ['pageTitleListener'],
    data(){
        return{
            breadcrumbs: [],
            page_title: ''
        }
    },
    methods:{
        async getBreadCrumbs(){
            let response = await fetch(`/api/breadcrumbs?route=${window.location.pathname}`, {
                method: 'GET',
                credentials: 'include'
            });

            let results = await checkAuth(response);

            if (response.status === 200){
                if(results){
                    if(this.custom_breadcrumbs.length != 0){
                        this.breadcrumbs = this.custom_breadcrumbs;
                    }
                    else{
                        this.page_title = results[0].name;
                        this.$emit('pageTitleListener', this.page_title);
                        this.breadcrumbs = results.reverse();
                    }
                }
            }
        },
        crumbClick(crumb){
            this.$router.push(`/${crumb.sef_url}`);
        }
    },
    beforeMount(){
        this.getBreadCrumbs();
    }
}
</script>

<style lang="scss" scoped>
.breadcrumbs{
    color: var(--black);
    font-size: 1rem;
    font-weight: 600;
    text-transform: capitalize;
    display: flex;
    gap: 6px;
    // text-transform: uppercase;
}

.crumbs{
    display:flex; 
    gap: 10px;
}

.crumb{
    cursor: pointer;
}
</style>